import { Card } from "@mui/material";
import { useParams } from "react-router-dom";
import MessagesPane from "./messages/MessagesPane";
import PageLayout from "../page-layout/PageLayout";

export default function UserRequestChat() {
  const { id } = useParams();
  return (
    <PageLayout title="Обращение">
      <Card sx={{ overflow: "hidden" }}>
        <MessagesPane chatId={id} />
      </Card>
    </PageLayout>
  );
}
